<script setup lang="ts">

import type { IOfferTile } from "@domain/Marketplace";
import HorizontalDragScroll from "../Common/HorizontalDragScroll.vue";
import { OfferTile } from "@app/MyMarketplace";
import { OfferHeaderStyle } from "@app/MyMarketplace/Types/OfferHeaderStyle";
import { useRouter } from "@library/Services";

type Props = { 
    title?: string, 
    subTitle?: string, 
    totalCount?: number
    unfilteredCount?: number,
};

const model = defineModel<IOfferTile[]>( { required: true } );
const { title, subTitle, totalCount = 0 } = defineProps<Props>();

/**
 * Navigate to the offer page
 * @param itemId 
 */
function onItemClick( itemId: string ) 
{
    const router = useRouter();
    router.go( `/my-marketplace/offer/${ itemId }` );
}

</script>

<template>

    <div class="flex flex-col gap-2 3xl:gap-3
                bg-gradient-to-b from-gray-900 via-40% via-gray-850 to-gray-900">

        <h1 v-if="title"
            class="px-4 3xl:px-6 flex items-center justify-between tracking-wider text-base 3xl:text-xl">
            <span>{{ title }}</span>
            <RouterLink v-if="totalCount > model.length"
                        to="/my-marketplace"
                        class="uppercase text-secondary-500 text-xs 3xl:text-base">
                See All
            </RouterLink>
        </h1>

        <h2 v-if="subTitle"
            class="-mt-2 px-4 3xl:px-6 tracking-wider text-sm 3xl:text-lg opacity-40">
            <span>{{ subTitle }}</span>
        </h2>

        <HorizontalDragScroll class="flex-1 z-10 flex gap-x-4"
            @on-select="( itemId: string ) => onItemClick( itemId )">

            <template v-for="(offer, index) in model" 
                      :key="offer.offerId">
                <OfferTile :offer="offer" 
                           :value="offer.offerId"
                           :header-style="OfferHeaderStyle.Medium"
                           :enable-click-to-open="false"
                           class="mx-2 first:ml-4 last:mr-4 3xl:first:ml-6 3xl:last:mr-6 w-[70%] min-w-[70%]" />
            </template>   

        </HorizontalDragScroll>
        
    </div>
    
</template>